import React from 'react';
import { HeartXS } from '@lux/icons';
import { Text, Preset } from '@lux/text';
import { SupportingColor } from '@lux/tokens';

import { CampaignDeliveryPromise } from '@shared/types/mylounge';
import { VALENTINE_EVENT_DELIVERY_PROMISE } from '@client/config/constants';

import { WrapperSection } from './styles';

type DeliveryPromiseType = typeof VALENTINE_EVENT_DELIVERY_PROMISE | string;

type Promise = CampaignDeliveryPromise & {
    type: DeliveryPromiseType;
};

// eslint-disable-next-line no-undef
const PromiseIcon: Record<DeliveryPromiseType, JSX.Element> = {
    [VALENTINE_EVENT_DELIVERY_PROMISE]: <HeartXS color={SupportingColor.info} />,
};

export const SpecialBanner = ({ promise }: { promise: Promise }) => (
    <WrapperSection>
        {PromiseIcon[promise.type]}
        <Text preset={Preset.XS} bold>
            {promise.text}
        </Text>
    </WrapperSection>
);

export default SpecialBanner;
